

















































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
import { getStore } from '@/utils/utils'
@Component
export default class accountManage extends Vue {
  phoneNum: string = ''
  userImg: any = '' // 用户头像
  //用户头像列表
  userImgList: any = {
    '1.png': require('../../../assets/custerImgs/1.png'),
    '2.png': require('../../../assets/custerImgs/2.png'),
    '3.png': require('../../../assets/custerImgs/3.png'),
    '4.png': require('../../../assets/custerImgs/4.png'),
    '5.png': require('../../../assets/custerImgs/5.png'),
    '6.png': require('../../../assets/custerImgs/6.png'),
    '7.png': require('../../../assets/custerImgs/7.png'),
    '8.png': require('../../../assets/custerImgs/8.png'),
    '9.png': require('../../../assets/custerImgs/9.png'),
    '10.png': require('../../../assets/custerImgs/10.png'),
    '11.png': require('../../../assets/custerImgs/11.png'),
    '12.png': require('../../../assets/custerImgs/12.png')
  }
  created() {
    this.phoneNum = getStore('userInfo') ? JSON.parse(getStore('userInfo')).mobile : ''
    this.userImg = this.userImgList[getStore('userImg')] // user头像
  }
  cellHandel(type) {
    switch (type) {
      case 'phone':
        this.$router.push({ path: '/changePhoneNum' })
        break
      case 'pay':
        this.$router.push('/updatePayPassword')
        break
      case 'card':
        this.$router.push('/bankManageList')
        break
      case 'see':
        this.$router.push('/protocol')
        break
      case 'help':
        this.$router.push('/helpQuestion')
        break
      case 'header':
        this.$router.push('/replaceImg')
        break
      case 'close':
        this.$router.push('/closePay')
        break
      default:
        break
    }
  }
}
